import { useTranslation } from '@/hooks/use-translation'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'
import { AgenciesTable } from './agencies-table'

export default function AdminAgencies() {
  const { t } = useTranslation()

  return (
    <>
      <UnifiedHeader />

      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              {t('agencies.agencyManagement')}
            </h2>
            <p className='text-muted-foreground'>
              {t('agencies.manageAgenciesHere')}
            </p>
          </div>
        </div>

        <div className='flex-1 overflow-auto'>
          <AgenciesTable columns={[]} />
        </div>
      </Main>
    </>
  )
}
